import { formSubmitHandler } from '../../components/layout-a/forms/common/formSubmitHandler';
import storeDataToLocal from 'components/layout-a/forms/common/StoreDataToLocalStorage';
import { getFileSize } from '../../lib/common/common';
import downloadFile from '../../lib/common/downloadFile';
import { notify } from '../../lib/common/notify';
import { tracker } from '../../lib/events/tracker';
import { getUserLocationData } from '../../lib/common/userLocation';
import { getIP } from '../../lib/api/ipApi';
import { getUtmParams } from '../../lib/common/utm';
import { randomCodeGenerator } from '../../lib/common/utm';

const MCSubmitHandler = async (
  data?: any,
  extraData?:
    | {
        leadType?: string;
        static_lead_type?: string;
        page?: string;
        action?: string;
        name?: string;
        label?: string;
        program?: string;
      }
    | any,
  reset?: any,
  setOpenSuccessPopup?: any,
  setLeadData?: any,
  courseBrochure?: any
) => {
  const { leadType, eventData } = extraData;

  // Certifying_authority check
  if (data.certifying_authority?.length) {
    return;
  }

  const dataCopy = {
    ...data,
  };
  delete dataCopy.course_name;
  delete dataCopy.country_name;
  delete dataCopy.city_name;

  // getCurrentLocation
  const location = await getUserLocationData();
  const ipData = await getIP();
  const ipAddress = ipData.ip;
  const utmParams = getUtmParams();
  const randomCode = randomCodeGenerator();
  const defaultData = {
    code: randomCode,
    ip_address: ipAddress,
    utm_parameters: utmParams,
  };

  const leadData = { ...defaultData, ...dataCopy, ...extraData };

  const extraLeadData = {
    firstName: leadData.first_name,
    lastName: leadData.last_name,
    email: leadData.email,
    phone: leadData.phone,
    utmFormId: `${leadData?.program?.split(' ')[0]}_MASTER_CLASS_APPLY_NOW'`,
    enableWhatsApp: 'YES',
    yearsOfExperience: leadData.user_experience,
    query: leadData.query,
    program: leadData.program,
    utmMedium: utmParams.UMEDIUM,
    utmSource: utmParams.USOURCE,
    url: leadData.page,
    utmCampaign: utmParams.UCAMPAIGN,
    utmTerm: utmParams.UTERM,
    utmContent: utmParams.UCONTENT,
    detectedCity: location.city.name,
    detectedCountry: location.country.name,
  };


  const response = await formSubmitHandler(leadData, leadType);

  if (response.result.status) {
    // tracker
    tracker({
      trackerType: 'all',
      eventAction: extraData.action,
      eventActionType: 'Submit',
      eventName: extraData.name,
      eventLabel: extraData.label,
      data: { ...data, ...extraData, ...extraLeadData },
    });

    delete data.course_name;
    delete data.country_name;
    delete data.city_name;

    if (extraData.leadType === 'unlockCurriculumPreviewVideo') {
      localStorage.setItem('CurriculumFormSubmitted', JSON.stringify({ formSubmitted: true }));
    }

    if (extraData.leadType == 'masterClassBookSeatQuery') {
      setLeadData({ leadID: response.result.id, email: leadData.email });
    }

    setOpenSuccessPopup(true);
    storeDataToLocal(data);
    reset();

    if (courseBrochure && courseBrochure.length) {
      let brochurePath = `${process.env.NEXT_PUBLIC_WEB_DOMAIN}/${courseBrochure}`;
      const fileSize = getFileSize(brochurePath);
      if (fileSize == 0) {
        brochurePath = `${process.env.NEXT_PUBLIC_AWS_URI}/${courseBrochure}`;
      }

      // Downloading file
      downloadFile({ type: 'pdf', filePath: brochurePath });
    }
    return { success: true };
  }
  return notify('error', response.result.message);
};

export default MCSubmitHandler;
